import React from 'react';
import {
  targetQuantity, remainingQuantity, isLineComplete, formatLineQuantity, formatEquivalence,
} from '../utils/loadingScan';
import '../styles/scanFeedback.css';

// Panel under the inputs of Beta #1 of the loading screen. One state at a
// time: the product waiting for its second beep, the receipt of the last
// entry, a code that is not in the order, or a line that needs nothing more.
// Beta #2 keeps ScanFeedback.js.
function CargaBetaFeedback({ feedback, scannedQuantity, onUndo }) {
  if (!feedback) return null;

  const panel = (modifier, children, live = 'polite') => (
    <section className={`scan-feedback scan-feedback--${modifier}`} aria-label="Último escaneo" aria-live={live}>
      {children}
    </section>
  );

  const head = (line) => (
    <div className="scan-feedback__head">
      <h2 className="scan-feedback__name">{line.sku_name}</h2>
      <span className="scan-feedback__sku">SKU {line.sku_code}</span>
    </div>
  );

  if (feedback.kind === 'rejected') {
    return panel('rejected', (
      <>
        <p className="scan-feedback__target">No es producto de esta carga</p>
        <p className="scan-feedback__code">Código: {feedback.code}</p>
      </>
    ), 'assertive');
  }

  if (feedback.kind === 'complete') {
    const { line } = feedback;
    return panel('complete', (
      <>
        {head(line)}
        <p className="scan-feedback__target">Línea completa, no falta nada</p>
        <div className="scan-feedback__facts">
          <p>Total verificado: {formatLineQuantity(line, scannedQuantity(line.sku_code))}</p>
        </div>
      </>
    ), 'assertive');
  }

  if (feedback.kind === 'identified') {
    const { line, readWeight, weightProblem } = feedback;
    const verified = scannedQuantity(line.sku_code);
    const equivalence = formatEquivalence(line);
    return panel('identified', (
      <>
        {head(line)}
        <p className="scan-feedback__target">A cargar: {formatLineQuantity(line, targetQuantity(line))}</p>
        <div className="scan-feedback__facts">
          <p>Ya verificado: {formatLineQuantity(line, verified)}</p>
          <p>Falta: {formatLineQuantity(line, remainingQuantity(line, verified))}</p>
          {equivalence && <p>{equivalence}</p>}
        </div>
        {line.format_unit_kg && readWeight !== null && (
          <p className="scan-feedback__weight">Peso leído: {formatLineQuantity(line, readWeight)}</p>
        )}
        {weightProblem === 'missing' && <p className="scan-feedback__warning">Ingrese el peso</p>}
        {weightProblem === 'invalid' && <p className="scan-feedback__warning">Peso no válido</p>}
        <p className="scan-feedback__hint">
          {line.format_unit_kg
            ? 'Escanee de nuevo para confirmar, o corrija el peso y presione Enter'
            : 'Escanee de nuevo para confirmar'}
        </p>
      </>
    ));
  }

  const { item, quantity } = feedback;
  const total = scannedQuantity(item.sku_code);
  const over = total - targetQuantity(item) > 1e-9;
  return panel(over ? 'over' : 'registered', (
    <>
      <span className="scan-feedback__badge">Registrado</span>
      {head(item)}
      <p className="scan-feedback__target">Ingresado: {formatLineQuantity(item, quantity)}</p>
      <div className="scan-feedback__facts">
        <p>Total verificado: {formatLineQuantity(item, total)}</p>
        <p>A cargar: {formatLineQuantity(item, targetQuantity(item))}</p>
      </div>
      {over ? (
        <p className="scan-feedback__warning">Supera lo pedido</p>
      ) : (
        isLineComplete(item, total) && <p className="scan-feedback__complete">Línea completa</p>
      )}
      <div className="scan-feedback__actions">
        <button type="button" className="scan-feedback__undo" onClick={onUndo}>
          Deshacer
        </button>
      </div>
    </>
  ));
}

export default CargaBetaFeedback;
